import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LProps, withLocalization } from '../../utils/wrappers';
import { CompetitionUserScore, UserRead, Entity } from '../../userApi';
import { State } from '../../redux/state';
import { makeUserPath, makeEntityPath } from '../../utils/routerHelper';
import { displayFullName } from '../../utils/userApiHelper';
import * as selectors from '../../redux/selectors';
import { Link } from 'react-router-dom';
import { estimateEntityDollarSavings } from '../../utils/actionSavings';

interface ManualProps {
  score: CompetitionUserScore;
  rank: number;
  showCampus: boolean;
  showSavings: boolean;
}

interface Props extends ManualProps {
  user: UserRead;
  campus: Entity;
  competitionID: number;
  dollarsSaved: number;
}

const CompetitionUserScoreRow_ = ({
  rank, user, score, campus, formatNumber, competitionID, t,
  showCampus, showSavings, dollarsSaved
}: LProps<Props>) => {
  const waterGallons = Number(score.savingsWaterOz || 0);
  return (
    <tr>
      <td>{rank}</td>
      <td><Link to={makeUserPath(competitionID, user, t)}>{displayFullName(user)}</Link></td>
      {showCampus && (
        <td>{campus && <Link to={makeEntityPath(competitionID, campus, t)}>{campus.name}</Link>}</td>
      )}
      <td>{formatNumber(score.pledgeCount || 0)}</td>
      <td>{formatNumber(score.points)}</td>
      <td>{formatNumber(score.savingsCO2Lbs || 0)}</td>
      {showSavings && <td>{formatNumber(waterGallons, 0)}</td>}
      {showSavings && <td>${formatNumber(Math.round(dollarsSaved), 0)}</td>}
    </tr>
  );
};

const mapStateToProps = (state: State, ownProps: ManualProps) => ({
  user: state.users[ownProps.score.userID],
  campus: selectors.acceptedUniversity(state, ownProps.score.userID),
  competitionID: state.competition.id,
  dollarsSaved: estimateEntityDollarSavings(ownProps.score, state.competitionPledges)
});

export default compose(
  connect(mapStateToProps),
  withLocalization('topUserScores')
)(CompetitionUserScoreRow_) as React.ComponentClass<ManualProps>;
